import React from 'react'

function Service4() {
    return (
        <div>
            <h1>Banglore 4</h1>
        </div>
    )
}

export default Service4
